import React from 'react';
import { Helmet } from 'react-helmet';
export const MetaTags = ({ fields }) => {
    var _a, _b, _c, _d, _e;
    if (!fields || !((_a = fields) === null || _a === void 0 ? void 0 : _a.items) || !((_c = (_b = fields) === null || _b === void 0 ? void 0 : _b.items) === null || _c === void 0 ? void 0 : _c.length)) {
        console.warn('Meta Tags Component requires fields to be provided');
        return null;
    }
    const metaTags = (_e = (_d = fields) === null || _d === void 0 ? void 0 : _d.items) === null || _e === void 0 ? void 0 : _e.map((item, index) => {
        var _a, _b, _c, _d;
        const { name, content, ogMetaTag } = ((_a = item) === null || _a === void 0 ? void 0 : _a.fields) || {};
        const nameValue = (_b = name) === null || _b === void 0 ? void 0 : _b.value;
        const contentValue = (_c = content) === null || _c === void 0 ? void 0 : _c.value;
        if (((_d = ogMetaTag) === null || _d === void 0 ? void 0 : _d.value) === true) {
            return React.createElement("meta", { property: nameValue, content: contentValue, key: index.toString() });
        }
        else {
            return React.createElement("meta", { name: nameValue, content: contentValue, key: index.toString() });
        }
    });
    return React.createElement(Helmet, null, metaTags);
};
